module.exports = __webpack_public_path__ + "static/img/aqxj.1ea1d56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aqxj.jpg
// module id = hc3v
// module chunks = 0